export const errorString = (err) =>
  err
    ? typeof err === "string"
      ? err
      : err.message
      ? err.message
      : err.toString()
    : "Error";
